import type { PartnerConfig } from "@/content/partners/types"

export const PARK_CLUB_PARTNER_SLUG = "park-club"

export const PARK_CLUB_LOGO_PATH = "/partners/park-club/logo.png"

/**
 * Código de carteira da Fernanda da Silva Barbosa em produção
 * (`seller_referral_codes.code`). Staging pode não ter o perfil — o signup
 * ignora código inexistente sem bloquear o cadastro.
 */
export const PARK_CLUB_PORTFOLIO_SELLER_CODE = "D6NKJX8E"

/** Verde e dourado da marca Park Club — só kicker/anel; CTAs ficam Action-Blue. */
export const parkClubBrand = {
  accent: "#2D4A3E",
  accentDark: "#1F3A30",
  accentLight: "#C4A574",
  navy: "#21404F",
  ringFrom: "#C4A574",
  ringTo: "#2D4A3E",
  benefit: "#4ade80",
  benefitForeground: "#002a50",
} as const

export const parkClubPartnerConfig: PartnerConfig = {
  slug: PARK_CLUB_PARTNER_SLUG,
  name: "Park Club",
  fullName: "Park Club Residencial",
  logoPath: PARK_CLUB_LOGO_PATH,
  benefitMode: "percent_increment",
  benefitPercentIncrement: 5,
  isActive: true,
  forcedSellerReferralCode: PARK_CLUB_PORTFOLIO_SELLER_CODE,
  metadata: {
    industry: "condominio",
    portfolio_seller_name: "Fernanda da Silva Barbosa",
  },
}

export const parkClubPartnerContent = {
  ...parkClubPartnerConfig,
  tagline: "Condomínio residencial com área verde e lazer",
  benefitHeadline: "Benefício para moradores",
  heroHeadline: "Moradores do Park Club Residencial têm desconto extra na energia",
  heroSubtitle:
    "Economize até 30% do total da sua conta de luz com a energia solar por assinatura da Astra.",
  partnershipIntro:
    "Moradores do Park Club Residencial têm 5% a mais de desconto na energia por assinatura do que sem a parceria. Cadastro simples, benefício automático por este link.",
  partnershipTitle: "Park Club Residencial e energia limpa, juntos",
} as const
